import React, { Component } from 'react';
import Style from '../licenseManagement.module.css';
import { connect } from 'react-redux';
import { getDevices, getDeviceStats, setCurrentDevice} from '../../store/entities/lmDevicesUsers';
import EnterIcon from '../../assets/Enter_Arrow_Right.svg';
import { formatDetectionDatetime } from '../../utilities/datetime'
import LoaderWrapper from '../common/LoaderWrapper/LoaderWrapper';
import { isGlobalView } from '../../utilities/config';
import SelectBox from '../common/selectbox/selectBox';
import searchIcon from '../../assets/magnifier.svg';
import Tooltip from '../common/popover/tooltip';
import Paginator from '../common/paginator/paginator'


const SORT_BY_OPTIONS = {
    created: {fieldName: 'CreatedOn', displayName: 'Created Date', abrev: 'crtOn'},
    name: {fieldName: 'OSComputerName', displayName: 'Device Name', abrev: 'dvcNm'},
    default: {fieldName: 'CreatedOn', displayName: 'Created Date', abrev: 'crtOn'},
}

const SORT_BY_DIRECTIONS = {
    asc: {displayName: 'Ascending', abrev: 'asc'},
    desc: {displayName: 'Descending', abrev: 'desc'},
    default: {displayName: 'Descending', abrev: 'desc'},
}

class DeviceTab extends Component {

    state = {
        deviceSearchText: '',
        deviceStatusFilter: 'all',
        deviceSortField: SORT_BY_OPTIONS.default.fieldName,
        deviceSortDir: SORT_BY_DIRECTIONS.default.abrev,
        customerChanged: false,
        deviceFilters : {
            pageNo: 1,
            pageSize: 5,
            searchTerm: '', 
            isActive: null,
            sortBy: `${SORT_BY_OPTIONS.default.abrev}|${SORT_BY_DIRECTIONS.default.abrev}`,
        }
    }

    componentDidMount = () => {
        // Restore tab from navigation state (e.g. returning from detail page)
        if (this.props.location && this.props.location.state && this.props.location.state.tab) {
            this.setState({ selectedTab: this.props.location.state.tab });
        }
    
        if (this.props.selectedCustomer) {
            this.populateDeviceData();
        }
    }
  
    componentDidUpdate(prevProps, prevState) {
        const prevSelectedCustomerId = prevProps.selectedCustomer && prevProps.selectedCustomer.id;  
        const currentSelectedCustomerId = this.props.selectedCustomer && this.props.selectedCustomer.id;  

        const prevMatchId = prevProps.matchParams && prevProps.matchParams.id;  
        const currentMatchId = this.props.matchParams && this.props.matchParams.id;  

        const customerChanged = prevSelectedCustomerId !== currentSelectedCustomerId && !!currentSelectedCustomerId;  
        const routeChanged = prevMatchId !== currentMatchId && !!currentMatchId;  

        if (customerChanged || routeChanged) {  
            this.populateDeviceData();  
        }  
    }

    populateDeviceData = () => {
        if(this.props.selectedCustomer) {
            const selectedId = this.props.matchParams.id;
            const defaultCustomerId = this.props.selectedCustomer?.defaultCustomerId;
            const globalView = isGlobalView(this.props.selectedCustomer?.organizationName);
            this.props.getDeviceStats(selectedId, defaultCustomerId, globalView);
            this.props.getDevices(this.getDeviceFilters(this.state.deviceFilters), selectedId, defaultCustomerId, globalView);
        }
    }

    getDeviceFilters = (filters) => {
        // Remove null or undefined values from filters
        return Object.fromEntries(
        Object.entries({ ...filters, pageSize: filters.pageSize + 1 }).filter(([_, v]) => v != null)
        ); 
    }

    onDeviceActionClick = (row) => {
        const customerId = this.props.selectedCustomer?.id || this.props.matchParams.id;
        this.props.setCurrentDevice(row);
        if (!isGlobalView(this.props.selectedCustomer?.organizationName)) {
            this.props.history.push(`/customers/${customerId}/device/${row.deviceId}`);
        } 
        else {
            this.props.history.push(`/tenants/${customerId}/${row.CustomerId}/device/${row.deviceId}`);
        }
    }

    devicesGridDef = {
        name: 'deviceList',
        columns: [
        { fieldName: 'OSComputerName', displayName: 'Device Name', width: '30%', className: Style.boldFont },
        { fieldName: 'CreatedOn', displayName: 'Detail', dataType: 'date', subType: 'datetime', prefix: 'Created At', width: '30%', className: Style.boldFont },
        { fieldName: 'isActive', displayName: 'Status', dataType: 'boolean', trueValue: 'Active', falseValue: 'Inactive', width: '30%', className: Style.boldFont },
        { fieldName: 'action', displayName: 'Action', dataType: 'image', src: EnterIcon, width: '50px', onClick: this.onDeviceActionClick, className: Style.boldFont }
        ]
    }

    getFilteredDevices = ({ resetPage = false } = {}) => {
        const { deviceSearchText, deviceStatusFilter, deviceSortField, deviceSortDir } = this.state;
        const selectedId = this.props.matchParams.id;
        const defaultCustomerId = this.props.selectedCustomer?.defaultCustomerId;
        const globalView = isGlobalView(this.props.selectedCustomer?.organizationName);
        const isActiveFilter = deviceStatusFilter === 'all' ? null : deviceStatusFilter === 'active';
        const sortBy = `${SORT_BY_OPTIONS[deviceSortField]?.abrev || SORT_BY_OPTIONS.default.abrev}|${SORT_BY_DIRECTIONS[deviceSortDir]?.abrev || SORT_BY_DIRECTIONS.default.abrev}`;
        const pageNo = resetPage ? 1 : (this.state.deviceFilters?.pageNo || 1);
        if (resetPage) {
            this.setState(s => ({ deviceFilters: { ...s.deviceFilters, pageNo: 1 } }));
        }
        const filters = {
            pageNo,
            pageSize: this.state.deviceFilters?.pageSize || 5,
            searchTerm: deviceSearchText,
            isActive: isActiveFilter,
            sortBy,
        };
        this.props.getDevices(this.getDeviceFilters(filters), selectedId, defaultCustomerId, globalView);
    }

    _deviceSearchTimer = null;

    handleDeviceSearch = (searchTerm) => {
        this.setState({ deviceSearchText: searchTerm });
        if (this._deviceSearchTimer) clearTimeout(this._deviceSearchTimer);
        this._deviceSearchTimer = setTimeout(() => {
            this.setState(
                s => ({ deviceFilters: { ...s.deviceFilters, pageNo: 1 } }),
                () => this.getFilteredDevices({resetPage: true})
            );
        }, 300);
    }

    handleDeviceSelect = (selectedOption) => {
        if (selectedOption && selectedOption.id && selectedOption.id !== 'all') {
            this.setState({ deviceSearchText: selectedOption.name || '' }, () => this.getFilteredDevices({ resetPage: true }));
        } else {
            this.setState({ deviceSearchText: '' }, () => this.getFilteredDevices({ resetPage: true }));
        }
    }

    handleCustomerChange = () => {
        this.setState({ customerChanged: false });
    }

    formatDevicesForSelectBox = () => {
        return this.props.devices?.length > 0 ? this.props.devices.map(device => ({
            name: device.OSComputerName || device.DeviceIdentifier || device.deviceId,
            id: device.deviceId
        })) : [];
    }

    loadNextDevices = () => {
        if(this.props.isLastPage) {
            return; // No more data to load
        }
        let nextPageNo = this.state.deviceFilters.pageNo + 1;
        this.setState(() => ({ deviceFilters: { ...this.state.deviceFilters, pageNo: nextPageNo } }), this.getFilteredDevices);
    }

    loadPrevDevices = () => {
        let prevPageNo = Math.max(this.state.deviceFilters.pageNo - 1, 1);
        this.setState(() => ({ deviceFilters: { ...this.state.deviceFilters, pageNo: prevPageNo } }), this.getFilteredDevices);
    }

    render() {

        return (
        <>
            <div className={`${Style.workArea}`}>
            <div className={`${Style.headerContiner} mt-1 p-4 px-5 d-flex`} style={{ height: 'auto', minHeight: '131px' }}>
                <div className={`${Style.borderStyle} pl-3 pr-5`}>
                <div className={`${Style.activeUsersFontStyle}`}>Total Devices</div>
                <div className={`${Style.countStyle}`}>
                    {this.props.deviceStatsLoading
                    ? <LoaderWrapper loading={true} waitForData={false} styles={{ minHeight: '60px'}} isFlex={true} />
                    :  this.props.deviceStats?.ttlDvc || 0}
                </div>
                </div>
                <div className={`${Style.borderStyle} pl-3 pr-5`}>
                <div className={`${Style.activeUsersFontStyle}`}>Active Devices</div>
                <div className={`${Style.countStyle}`}>
                    {this.props.deviceStatsLoading
                    ? <LoaderWrapper loading={true} waitForData={false} styles={{ minHeight: '60px'}} isFlex={true} />
                    : this.props.deviceStats?.actDvc || 0}
                </div>
                </div>
            </div>
            </div>

            <div className={`${Style.workArea} mt-2`}>
            <div className={`${Style.userLicenses}`}>Device List</div>
            <div className={`mt-2 ${Style.pixmFilterBar} d-flex align-items-center px-3`}>
                <SelectBox
                    role="CustomerAdmin,PixmAdmin,TenantAdmin"
                    width="20%"
                    optionBoxWidth="300px"
                    source="DeviceTab"
                    options={[...[{ name: 'Device: All', id: 'all' }], ...this.formatDevicesForSelectBox()]}
                    defaultOption={{ name: 'Device: All', id: 'all' }}
                    onSelect={this.handleDeviceSelect}
                    onSearch={this.handleDeviceSearch}
                    icon={searchIcon}
                    customerChanged={this.state.customerChanged}
                    handleCustomerChange={this.handleCustomerChange}
                    type="devices"
                    showSearch={true}
                    minLengthToSearch={2}
                />
                <div className="d-flex align-items-center ml-3">
                {['all', 'active', 'inactive'].map(status => (
                    <button
                    key={status}
                    onClick={() => this.setState({ deviceStatusFilter: status }, () => this.getFilteredDevices({ resetPage: true }))}
                    style={{
                        marginLeft: '6px',
                        padding: '5px 14px',
                        borderRadius: '5px',
                        border: '1px solid #e3e3e3',
                        fontFamily: 'Roboto',
                        fontSize: '13px',
                        cursor: 'pointer',
                        backgroundColor: this.state.deviceStatusFilter === status ? '#6eb0e1' : '#f7f7f7',
                        color: this.state.deviceStatusFilter === status ? '#fff' : '#333',
                        fontWeight: this.state.deviceStatusFilter === status ? 'bold' : 'normal',
                    }}
                    >
                    {status.charAt(0).toUpperCase() + status.slice(1)}
                    </button>
                ))}
                </div>
                <div className="d-flex align-items-center ml-4">
                <span style={{ fontFamily: 'Roboto', fontSize: '13px', color: '#333', marginRight: '8px' }}>Sort by:</span>
                <select
                    value={this.state.deviceSortField}
                    onChange={(e) => this.setState({ deviceSortField: e.target.value }, () => this.getFilteredDevices({ resetPage: true }))}
                    style={{ height: '34px', borderRadius: '5px', border: '1px solid #e3e3e3', padding: '0 8px', fontFamily: 'Roboto', fontSize: '13px', backgroundColor: '#f7f7f7', outline: 'none', cursor: 'pointer' }}
                >
                    {Object.entries(SORT_BY_OPTIONS).filter(([key, option]) => key !== 'default').map(([key, option]) => (
                        <option key={key} value={key}>{option.displayName}</option>
                    ))}
                </select>
                <button
                    onClick={() => this.setState(s => ({ deviceSortDir: s.deviceSortDir === 'asc' ? 'desc' : 'asc' }), () => this.getFilteredDevices({ resetPage: true }))}
                    title={this.state.deviceSortDir === 'asc' ? 'Ascending' : 'Descending'}
                    style={{ marginLeft: '6px', width: '34px', height: '34px', borderRadius: '5px', border: '1px solid #e3e3e3', backgroundColor: '#f7f7f7', cursor: 'pointer', fontSize: '16px' }}
                >
                    {this.state.deviceSortDir === 'asc' ? '↑' : '↓'}
                </button>
                </div>
            </div>
            </div>

            <div className={`${Style.workArea}`}>
                <table className="listTable mb-5">
                <thead className="tableHead">
                    <tr>
                    {
                    this.devicesGridDef.columns.map((col) => (
                        <th key={col.fieldName} style={{ width: col.width, minWidth: '80px' }} className={col.className}>{col.displayName}</th>
                    ))
                    }
                    </tr>
                </thead>
                <tbody>
                {
                    this.props.devicesLoading ?
                    (<tr><td colSpan={this.devicesGridDef.columns.length}>
                        <LoaderWrapper loading={this.props.devicesLoading}  data={this.props.devices} waitForData={true} styles={{ minHeight: '380px' }} isFlex={true} placeholderText={"No Records Found"} >
                            </LoaderWrapper> 
                    </td></tr>)
                    :
                    this.props.devices.length === 0 ?
                    (<tr><td colSpan={this.devicesGridDef.columns.length}>
                            <div className={"notFound"} style={{ fontSize: '18px', paddingTop:'20px'}}>
                                <p className={` `}>No Records Found</p>
                            </div>
                        </td>
                    </tr>
                    )
                    :
                    <>
                    {this.props.devices.slice(0, this.state.deviceFilters.pageSize).map((device) => (
                    <tr key={device.deviceId}>
                        <td style={{ minWidth: '290px' }}>
                            <div className={Style.boldFont}>{device.deviceName}</div>
                            <Tooltip id={device.deviceName} data={device.deviceName} />
                        </td>
                        <td style={{ minWidth: '350px' }}>
                            <i>
                                Created at{' '}
                                {formatDetectionDatetime(device.CreatedOn)}
                            </i>
                        </td>
                        <td style={{ minWidth: '170px' }}>
                            {device.isActive ? 'Active' : 'Inactive'}
                        </td>
                        <td style={{ minWidth: '50px' }}>
                        <img
                            className="rowDetail"
                            onClick={() => this.onDeviceActionClick(device)}
                            src={EnterIcon}
                            alt="next-icon"
                        />
                        </td>
                    </tr>
                    ))}
                </>}
                </tbody>
                </table>
                </div>
                <div className={`d-flex justify-content-center align-items-end`} >
                <Paginator
                    onNext={this.loadNextDevices}
                    onPrev={this.loadPrevDevices}
                    filters={this.getDeviceFilters({ ...this.state.deviceFilters, offset: (this.state.deviceFilters.pageNo - 1) * (this.state.deviceFilters.pageSize) })}
                    totalSize={this.state.deviceFilters.pageNo * (this.state.deviceFilters.pageSize)} // Show next page button until we have loaded all items for the current page
                    isLastPage={this.props.isLastPage}
                    cacheSize={this.props.devices.length}
                    from={'DeviceTab'}
                />
            </div>
            {/* </div> */}
        </>
        );
    }
}

const mapStateToProps = (state) => ({
    selectedCustomer: state.entities.customers.selected,
    deviceStats: state.entities.lmDevicesUsers.deviceStats,
    deviceStatsLoading: state.entities.lmDevicesUsers.deviceStatsLoading,
    devices: state.entities.lmDevicesUsers.devices,
    devicesLoading: state.entities.lmDevicesUsers.devicesLoading,
    devicesFilters: state.entities.lmDevicesUsers.devicesFilters,
    isLastPage: state.entities.lmDevicesUsers.isDevicesLastPage,
})

const mapDispatchToProps = (dispatch) => ({
    getDevices: (filters, selectedId, defaultCustomerId, isGlobalView) => dispatch(getDevices(filters, selectedId, defaultCustomerId, isGlobalView)),
    getDeviceStats: (selectedId, defaultCustomerId, isGlobalView) => dispatch(getDeviceStats(selectedId, defaultCustomerId, isGlobalView)),
    setCurrentDevice: (device) => dispatch(setCurrentDevice(device)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DeviceTab)
